module.exports = __webpack_public_path__ + "img/5.cf2f99f6.jpg";